import { ModelBase } from "@shoothill/core";
import { action, observable } from "mobx";

export class PaymentTermsModel extends ModelBase<PaymentTermsModel, PaymentTermsDTO> {
    // #region Constructors and Disposers
    // #endregion Constructors and Disposers

    // #region Defaults and Constants

    public static readonly DEFAULT_ID = "";
    public static readonly DEFAULT_DISPLAYNAME = "";

    // #endregion Defaults and Constants

    // #region Observables

    @observable
    public id: string = PaymentTermsModel.DEFAULT_ID;

    @observable
    public displayName: string = PaymentTermsModel.DEFAULT_DISPLAYNAME;

    // #endregion Observables

    // #region Actions

    @action
    public reset(): void {
        this.id = PaymentTermsModel.DEFAULT_ID;
        this.displayName = PaymentTermsModel.DEFAULT_DISPLAYNAME;
    }

    @action
    public fromDto(dto: PaymentTermsDTO): void {
        this.id = dto.id;
        this.displayName = dto.name;
    }

    public toDto() {
        throw new Error("Method not implemented.");
    }

    // #endregion Actions

    // #region Helpers

    public static fromDtos(dtos: PaymentTermsDTO[]): PaymentTermsModel[] {
        const types: PaymentTermsModel[] = [];

        for (const dto of dtos) {
            const model = new PaymentTermsModel();

            model.fromDto(dto);
            types.push(model);
        }

        return types;
    }

    // #endregion Helpers
}

export interface PaymentTermsDTO {
    id: string;
    name: string;
}
